import { base } from './environment.base';
import { IAppEnvironment } from './environment.types';

export const environment: IAppEnvironment = {
  ...base,
  PRODUCTION: true
};
